/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV7KachingNativeGifts) return;

  const KACHING = '__kaching_bundles';
  const MODE = 'personalized_real_gifts';
  const CART_READ_TIMEOUT_MS = 5000;
  const CART_MUTATION_TIMEOUT_MS = 8000;
  const copy = () => window.SafeWalkV6RealGiftCopy || {};
  const dogProperty = () => copy().dogNameProperty || 'שם הכלב';
  const phoneProperty = () => copy().phoneProperty || 'מספר טלפון';
  const contract = () => window.SafeWalkV7KachingNativeContract;
  const propertiesFor = (item) => item?.properties && typeof item.properties === 'object'
    ? item.properties
    : {};
  const lineTotal = (item) => Number.isFinite(Number(item?.final_line_price))
    ? Number(item.final_line_price)
    : Number(item?.final_price || 0) * Number(item?.quantity || 1);
  const validationKey = (personalization) => contract()?.validationKey(personalization) || '';
  const validateConfig = (config) => contract()?.validateConfig(config) === true;
  const readRootConfig = (root) => contract()?.readRootConfig(root)
    || { identities: [], realGiftIds: {} };
  const configFromRoot = (root) => contract()?.configFromRoot(root)
    || { identities: [], realGiftIds: {}, giftIds: {} };
  const mainContractProperties = () => ({});
  const personalizationControlKey = (input) => input?.dataset.safewalkPersonalizationKey
    || input?.name?.slice(11, -1)
    || '';
  const readPersonalization = (controls = []) => {
    const result = {};
    controls.forEach((input) => {
      const key = input.dataset.safewalkPersonalizationProperty || input.name?.slice(11, -1) || '';
      if (key && input.value?.trim()) result[key] = input.value.trim();
    });
    return result;
  };
  const splitPersonalization = (mode, properties = {}) => {
    const lineProperties = { ...properties };
    const personalization = {
      dogName: String(lineProperties[dogProperty()] || '').trim(),
      phone: String(lineProperties[phoneProperty()] || '').trim()
    };
    if (mode === MODE) {
      delete lineProperties[dogProperty()];
      delete lineProperties[phoneProperty()];
    }
    Object.keys(lineProperties)
      .filter((key) => key.startsWith('_safewalk_'))
      .forEach((key) => delete lineProperties[key]);
    return { lineProperties, personalization };
  };
  const cleanGiftProperties = (existing = {}, personalization = {}) => {
    const result = { ...existing };
    Object.keys(result)
      .filter((key) => key.startsWith('_safewalk_'))
      .forEach((key) => delete result[key]);
    delete result[dogProperty()];
    delete result[phoneProperty()];
    const dogName = String(personalization.dogName || '').trim();
    const phone = String(personalization.phone || '').trim();
    if (dogName) result[dogProperty()] = dogName;
    if (phone) result[phoneProperty()] = phone;
    return result;
  };
  const sameProperties = (current = {}, target = {}) => {
    const currentKeys = Object.keys(current).sort();
    const targetKeys = Object.keys(target).sort();
    return currentKeys.length === targetKeys.length
      && currentKeys.every((key, index) => (
        key === targetKeys[index] && String(current[key]) === String(target[key])
      ));
  };
  const fetchJson = (input, init, timeoutMs) => {
    const boundedFetch = window.SafeWalkV51KachingRecovery?.fetchJson;
    if (typeof boundedFetch !== 'function') return Promise.reject(new Error('cart-fetch-runtime'));
    return boundedFetch(input, init, timeoutMs);
  };
  const fetchCart = async () => {
    const { response, body } = await fetchJson('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }, CART_READ_TIMEOUT_MS);
    if (!response.ok) throw new Error(`cart-${response.status}`);
    return body;
  };
  const sectionIds = () => {
    const ids = new Set(['cart-drawer', 'cart-icon-bubble']);
    document.querySelectorAll(
      '[data-safewalk-real-gifts-section][data-section-id], cart-items[data-id], #main-cart-footer[data-id]'
    ).forEach((node) => ids.add(node.dataset.sectionId || node.dataset.id));
    document.querySelector('cart-drawer')?.getSectionsToRender?.()
      .forEach((section) => ids.add(section.id));
    return [...ids].filter(Boolean).slice(0, 5);
  };
  const changeLine = async (item, properties) => {
    const { response, body } = await fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: Number(item.quantity || 1),
        properties,
        sections: sectionIds(),
        sections_url: window.location.pathname
      })
    }, CART_MUTATION_TIMEOUT_MS);
    if (!response.ok || !body) throw new Error(`change-${response.status}`);
    return body;
  };
  const replaceSection = (sectionId, html) => {
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const current = document.getElementById(`shopify-section-${sectionId}`)
      || document.getElementById(sectionId);
    const fresh = parsed.getElementById(`shopify-section-${sectionId}`)
      || parsed.getElementById(sectionId);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };
  const render = (body) => {
    if (!body?.sections) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && body.sections['cart-drawer']) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(body);
    }
    Object.entries(body.sections).forEach(([id, html]) => {
      if (id !== 'cart-drawer' && id !== 'cart-icon-bubble') replaceSection(id, html);
    });
    document.dispatchEvent(new CustomEvent('safewalk:real-gifts-rendered'));
  };
  const resultItems = (result) => Array.isArray(result?.body?.items)
    ? result.body.items
    : result?.body?.id
      ? [result.body]
      : [];
  const resultGroupId = (result, config, state) => {
    const mains = resultItems(result).filter((item) => {
      const metadata = contract()?.metadataFor(item);
      const kind = contract()?.kindForMetadata(metadata, config);
      return metadata?.main === true && (!state?.kind || kind === state.kind);
    });
    return mains.length === 1 ? String(contract()?.metadataFor(mains[0])?.id || '') : '';
  };
  const groupFor = (cart, config, identifier = '') => {
    const groups = contract()?.classifyCart(cart, config)?.groups || [];
    return groups.find((group) => (
      group.groupId === String(identifier)
      || String(group.main?.key || '') === String(identifier)
    ));
  };
  const rollbackGroup = async (identifier) => {
    try {
      const cart = await fetchCart();
      const config = contract()?.configFromRegistry?.() || {};
      const group = groupFor(cart, config, identifier);
      if (!group) return true;
      const updates = Object.fromEntries(
        group.items.filter((item) => item.key).map((item) => [item.key, 0])
      );
      if (!Object.keys(updates).length) return true;
      const { response, body } = await fetchJson('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sectionIds(),
          sections_url: window.location.pathname
        })
      }, CART_MUTATION_TIMEOUT_MS);
      if (!response.ok || !body) return false;
      render(body);
      return !groupFor(await fetchCart(), config, group.groupId);
    } catch (error) {
      return false;
    }
  };
  const reconcileGroup = async ({ root, personalization = {}, result, state }) => {
    const config = configFromRoot(root);
    if (!validateConfig(config) || validationKey(personalization)) {
      return { ok: false, reason: 'gift-config' };
    }
    const groupId = resultGroupId(result, config, state);
    if (!groupId) return { ok: false, reason: 'gift-group' };
    try {
      let cart = await fetchCart();
      let group = groupFor(cart, config, groupId);
      if (!group?.complete) throw new Error('gift-contract');
      const tagIdentity = config.identities.find((identity) => identity.role === 'gift_tags');
      const tag = group.gifts.find((item) => (
        Number(item.product_id) === Number(tagIdentity?.productId)
        && Number(item.variant_id || item.id) === Number(tagIdentity?.variantId)
      ));
      if (!tag || lineTotal(tag) !== 0) throw new Error('gift-tags');
      const previousKaching = propertiesFor(tag)[KACHING];
      const targetProperties = cleanGiftProperties(propertiesFor(tag), personalization);
      if (sameProperties(propertiesFor(tag), targetProperties)) {
        window.SafeWalkV6RealGiftLifecycle?.acceptVerifiedCart?.(cart);
        window.SafeWalkV6CartSavingsTruth?.acceptCart?.(cart);
        return { ok: true, group };
      }
      const body = await changeLine(tag, targetProperties);
      cart = Array.isArray(body?.items) ? body : await fetchCart();
      group = groupFor(cart, config, groupId);
      const savedTag = group?.gifts.find((item) => (
        Number(item.product_id) === Number(tagIdentity?.productId)
        && Number(item.variant_id || item.id) === Number(tagIdentity?.variantId)
      ));
      if (!group?.complete
        || !savedTag
        || propertiesFor(savedTag)[KACHING] !== previousKaching) {
        throw new Error('gift-verification');
      }
      window.SafeWalkV6RealGiftLifecycle?.acceptVerifiedCart?.(cart);
      window.SafeWalkV6CartSavingsTruth?.acceptCart?.(cart);
      render(body);
      return { ok: true, group };
    } catch (error) {
      const rolledBack = await rollbackGroup(groupId);
      return {
        ok: false,
        rolledBack,
        reason: error instanceof Error ? error.message : 'gift-error'
      };
    }
  };
  const updateTag = async ({ groupId, personalization }) => {
    if (validationKey(personalization)) throw new Error('tag-phoneError');
    const config = contract()?.configFromRegistry?.() || {};
    let cart = await fetchCart();
    const group = groupFor(cart, config, groupId);
    const tagIdentity = config.identities?.find((identity) => identity.role === 'gift_tags');
    const tag = group?.gifts.find((item) => (
      Number(item.product_id) === Number(tagIdentity?.productId)
      && Number(item.variant_id || item.id) === Number(tagIdentity?.variantId)
    ));
    if (!group?.complete || !tag || lineTotal(tag) !== 0) throw new Error('tag-line');
    const previousKaching = propertiesFor(tag)[KACHING];
    const body = await changeLine(tag, cleanGiftProperties(propertiesFor(tag), personalization));
    cart = Array.isArray(body?.items) ? body : await fetchCart();
    const savedGroup = groupFor(cart, config, group.groupId);
    const savedTag = savedGroup?.gifts.find((item) => (
      Number(item.product_id) === Number(tagIdentity?.productId)
      && Number(item.variant_id || item.id) === Number(tagIdentity?.variantId)
    ));
    if (!savedGroup?.complete
      || !savedTag
      || propertiesFor(savedTag)[KACHING] !== previousKaching) {
      throw new Error('tag-verification');
    }
    window.SafeWalkV6RealGiftLifecycle?.acceptVerifiedCart?.(cart);
    window.SafeWalkV6CartSavingsTruth?.acceptCart?.(cart);
    render(body);
    return savedTag;
  };
  const cleanupStaleGifts = () => window.SafeWalkV6RealGiftLifecycle
    ?.reconcileExistingCart?.() || Promise.resolve(false);
  const api = Object.freeze({
    validationKey,
    validateConfig,
    readRootConfig,
    configFromRoot,
    mainContractProperties,
    personalizationControlKey,
    readPersonalization,
    splitPersonalization,
    reconcileGroup,
    rollbackGroup,
    updateTag,
    cleanupStaleGifts,
    render
  });
  window.SafeWalkV7KachingNativeGifts = api;
  window.SafeWalkV6RealGifts = api;
})();
